import {Injectable} from '@angular/core';
import {
  CalendarEventDate,
  CalendarEventModel
} from '../models/calendar-event.model';
import {addMinutesToStringDate} from '../functions/add-minutes-to-date.func';

@Injectable({
  providedIn: 'root'
})
export class GoogleCalendarService implements CalendarEventModel {
  public generateUrl({
    title,
    startDate,
    endDate,
    location,
    details
  }: CalendarEventDate): string {
    if (!title || !startDate || !endDate) {
      throw new Error(
        'Required parameters not delivered: title, startDate, endDate'
      );
    }

    const startTime = this.adjustOffset(startDate);
    const endTime = this.adjustOffset(endDate);
    const params = [
      {
        param: 'dates',
        value: `${startTime}/${endTime}`
      },
      {param: 'text', value: title},
      {param: 'location', value: location},
      {param: 'details', value: details},
      {param: 'crm', value: 'BUSY'}
    ]
      .map((x) => this.mergeParameters(x.param, x.value))
      .filter((x) => !!x)
      .join('&');

    return `https://calendar.google.com/calendar/render?action=TEMPLATE&${params}`;
  }

  private adjustOffset(date: string): string {
    const timezoneOffset = new Date(date).getTimezoneOffset();
    const utcTime = addMinutesToStringDate(date, timezoneOffset);
    return this.adjustDateString(new Date(utcTime).toISOString());
  }

  private adjustDateString(date: string): string {
    return date.split('-').join('').split(':').join('').replace('.000Z', 'Z');
  }

  private mergeParameters(param: string, value: string | undefined) {
    if (!!value) {
      return `${param}=${value}`;
    }
    return '';
  }
}
